
import{
  amPage,
  amBg,
  words,
}from './PageSplit.css'
export default function PageFirst(props){
  const isZh = window.getCurrentLangCode() === 'zh_CN' ? 'zh' : 'tw';
    return(
       <div className={`${amPage} PageFirst `} ref={ref=>props.pagesRef[0] = ref}>
         <div className={amBg} ></div>
          <div className="mainContent viewOne">
          {
            !props.loginModalShow && (
              <div className="laymid">
                <div className={`logo ${isZh}`}></div>
                <div className="clickMe clearfix">
                  <span className="loginBtn clickBtn " onClick={props.loginClick}>{lang.template("P_YS_FED_UCFBASEDOC_0000025215") /* "登录" */}</span>
                  {window._IUAPPREMISESFLAG ? null :<a target="_blank" href={props.registryUrl}  className="registryBtn clickBtn">{lang.template("P_YS_FED_UCFBASEDOC_0000025253") /* "立即注册" */}</a>}
                </div>
              </div>
            )
          }

          </div>
       </div>
    )
}
